module.exports = __webpack_public_path__ + "img/facebook-scaled.75895ccc.png";